export const MOD_INVENTORY_STORAGE = 'mod-inventory-storage';
export const MOD_USERS = 'mod-users';
export const MOD_PERMISSIONS = 'mod-permissions';
export const MOD_FQM_MANAGER = 'mod-fqm-manager';
export const MOD_CONSORTIA = 'mod-consortia';
